import src from "IMAGE";
export default { src, width: 4701, height: 880, blurWidth: 8, blurHeight: 1, blurDataURL: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAgAAAABCAYAAADjAO9DAAAALElEQVR42gEhAN7/AI1qtbI7NUFLNTU1SDAwMEMzMzNFKCgoNzQ0NEYzMzNFoIQIYnWLMSQAAAAASUVORK5CYII="};
